import { useState, useEffect, useRef } from 'react';
import ClipLoader from "react-spinners/PacmanLoader";
import { Container } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper} from "../pages/ContentStyles";
import { FaRegCheckCircle  } from 'react-icons/fa';

import {Branding} from './misc';

export default function useGetBackend(url) {
    const [data, setData] = useState(null);
    
    const [loading, setLoadning] = useState(true);
    const [resultVariant, setResultVariant] = useState(null);
    const [resultText,    setResultText]    = useState(null);
    const [resultVisible, setResultVisible] = useState(null);
    const [resultSuccess, setResultSuccess] = useState(true);
    const [initReady, setInitReady] = useState(false);

    var queryParam = useRef("");

    function Refresh(pageIndex=0, pageSize=25) {
        init(pageIndex, pageSize);
    }

    async function ReInit(urlx="", pageIndex=0, pageSize=25) {
        url = urlx;
        await init(pageIndex, pageSize);
    }    

    function Seek(QueryParam) {
        queryParam.current = QueryParam;
        init();
    }

    function Clear() {
        setData(null);
    }

    async function Update(updateDataObject, method = 'PATCH', toastTime = 3000, localUrl = '') {
        setLoadning(true);
        if (localUrl === '') localUrl = url;
        let { resultVariant, resultVisible, resultText } = await CallAPI(localUrl, method, JSON.stringify(updateDataObject));
        setResultVariant(resultVariant);
        setResultText(resultText);
        setResultVisible(resultVisible);

        setTimeout(() => {
            setResultVisible(false);
        }, 3000);     
        setLoadning(false);   
    }

    async function XCall(urlx, method = 'PUT', toastTime = 3000, updateDataObject = {}, noLoading = false) {
        if (!noLoading) setLoadning(true);
        let { resultVariant, resultVisible, resultText, errorsException, jsondata } = await CallAPI(urlx, method, JSON.stringify(updateDataObject));
        setResultVariant(resultVariant);
        setResultText(resultText);
        setResultVisible(resultVisible);
        setResultSuccess(!errorsException);

        setTimeout(() => {
            setResultVisible(false);
        }, 3000);
        
        if (!noLoading) setLoadning(false);
        return { resultVariant, resultVisible, resultText, errorsException, jsondata };
    }

    async function init(pageIndex=0, pageSize=25) {        
        if (url === '') {
            setLoadning(false);
            return;
        }
        setLoadning(true);
        try {
            var query = queryParam.current;
            if (pageIndex>0) {
                if (query.includes('?') || url.includes('?')) {
                    query=query+"&"+ "pageSize="+pageSize+"&pageIndex="+pageIndex;
                } else {
                    query="?pageSize="+pageSize+"&pageIndex="+pageIndex;
                }
            }

            const response = await fetch(url + query, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'accessToken':localStorage.getItem('access_token'),
                },
            });

            if (response.status === 401) window.location.href = "/login";                    

            if (response.ok) {
                //const json = await response.json();
                var json =  await response.json();

                if (json.errorsException) {  
                    setResultVariant('warning');
                } else {
                    setResultVariant('success');
                }

                setResultVisible(false);
                setResultText(json.resultText);
                setData(json);                
            } else {
                setResultVariant('warning');
                setResultVisible(true);
                setResultText('Ett fel uppstod!!');

                throw response;
            }
            
        }
        catch (e) {
            setResultVariant('warning');
            setResultVisible(true);
            setResultText('Ett fel uppstod!!!');
            setResultSuccess(false);
        }
        finally {
            setInitReady(true);
            setLoadning(false);
        }
    }

    useEffect(() => {init()}, [url]); 

    function GUIDx(){
        return { Rand : crypto.randomUUID(), Empty : "00000000-0000-0000-0000-000000000000" };
    }

    return { resultVariant, resultVisible, resultText, resultSuccess, loading, data, ReInit, Refresh, Seek, Clear, Update, XCall, GUIDx, initReady }; 
}

export async function CallDownload(url) {
    var filedata;
    try {
        const response =  await fetch(url, {
            method: "GET",
            headers: {
                'accessToken':localStorage.getItem('access_token'),
            }
        });

        if (response.ok) {
            const content = await response.blob();
            console.log(content.size);
            filedata=content;
        }
    }
    catch (e) {
    }
    finally {

    }
    return filedata; 
}

export async function CallAPI(url, method = 'GET', body = {}) {
    var resultVariant, resultVisible, resultText="...";
    var errorsException = false;
    var jsondata = {};
    try {
        var response = null;

        if (method === 'GET') {
            response = await fetch(url, {
                method: "GET",
                headers: {
                    'accessToken':localStorage.getItem('access_token'),
                }         
            });
        } else {
            response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    'accessToken':localStorage.getItem('access_token'),
                },            
                body: body
            });
        }

        if (response.ok) {
            jsondata =  await response.json();
            
            resultVisible=true;
            resultText=jsondata.resultText;

            errorsException=jsondata.errorsException;
            if (resultText==="") resultVisible = false;

            if (jsondata.errorsException) {
                resultVariant ="warning";    
            } else {
                resultVariant ="success";
            }

        } else {
            resultVariant ="warning";
            resultVisible=true;
            resultText= 'Ett fel uppstod!';
        }
    }
    catch (e) {
        resultVariant ="warning";
        resultVisible=true;
        resultText= 'Ett fel uppstod!!';
    }
    finally {

    }
    return { resultVariant, resultVisible, resultText, errorsException, jsondata }; 
}

export function IsLoggedIn() {    
    const [loggedIn, setLoggedIn] = useState(false);
    const [userName, setUserName] = useState("");
    const [isSuperUser, setIsSuperUser] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isReportUser, setIsReportUser] = useState(false);

    useEffect(() => {        
        async function init() {
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'AccessToken':localStorage.getItem('access_token'),
                    },
                });

                if (response.ok) {
                    const json =  await response.json();
                    setUserName(json.userName)
                    setLoggedIn(true);

                    setIsSuperUser(json.isSuperUser);
                    setIsReportUser(json.isReportUser);
                    setIsAdmin(json.isAdmin);
                } else {
                    setLoggedIn(false);
                }
            }
            catch (e) {
                console.log("IsLoggedIn: error");                
                setLoggedIn(false);

            }
        }

        var token = localStorage.getItem('access_token');
        var url = "/backend/auth/token/"+token+"/isValid";
        if (token!=="token" && token !== "" && token !== null) {            
            init();
        }
    });  

    return { loggedIn, userName, isAdmin, isSuperUser, isReportUser };     
}

export function XLogOff() {
    localStorage.setItem('access_token', "");
    //localStorage.setItem('isLoggedIn', true);
    window.location.href = "/login";
}

export function SpinnerX() {
    //let [color, setColor] = useState(Branding().ButtonColor);
    
      return (
      <div className="Spinner">
      <ClipLoader color={Branding().ButtonColor}  size={30} /><br></br>
      </div>
      )
    };

export function Loading() {

    let [loadingText, setLoadingText] = useState("Laddar");
    let [color, setColor] = useState(process.env.REACT_APP_BrandColor);

    return (
      <ContentWrapper>
          <Container>
              <Sida >
              <Rubrik>{loadingText}</Rubrik>
              <div className="Spinner">
                <ClipLoader color={Branding().ButtonColor}  size={30} /><br></br>
              </div>
          </Sida>
          </Container>
      </ContentWrapper>
    );  
};

    export function Check(props) {
        console.log(props.checked);
        if (props.checked) {
          return <FaRegCheckCircle />;
        } else {
          return "";
        }
      }  

     